
// BoatHouseRentee.js

import React from 'react';
import '../../styles/products/BoatHouseRentee.css';

import { FaSailboat } from "react-icons/fa6";
import { GrDocumentUser } from "react-icons/gr";
import { MdOutlineDisplaySettings } from "react-icons/md";
import renteeplaceholder from '../../images/products/boathouserentee/boathouseRenteeFrame.png';

import Logo from '../design/Logo';
import TitleField from '../text/TitleField';
import TextField from '../text/TextField';
import FeatureCard from '../design/FeatureCard';

import { useMediaQuery } from '../../hooks/useMediaQuery';

const product = {
    name: 'Boathouse Rentee App',
    overview: ' Empowers RAs to efficiently manage their fleet, increase bookings, and provide exceptional service to their customers.',
    visual: renteeplaceholder,
    orientation: 'landscape',
    features: [
        {
            title: 'Vessel Tracking',
            description: 'Monitor and manage your fleet in real-time.',
            icon: FaSailboat,
        },
        {
            title: 'Reduced Workload',
            description: 'Automate routine tasks and focus on what matters most.',
            icon: GrDocumentUser,
        },
        {
            title: 'Customizable',
            description: 'Tailor the app to your specific needs and workflows.',
            icon: MdOutlineDisplaySettings,
        },
    ],
};

const BoatHouseRentee = () => {
    // Mobile always shows feature cards in landscape style (icon beside
    // text) regardless of this product's own desktop orientation.
    const isMobileViewport = useMediaQuery('(max-width: 767px)');
    const featureOrientation = isMobileViewport ? 'landscape' : product.orientation;

    return (
        <section id="boathouse-rentee-app" className="product-showcase-container product-boathouse-rentee-app-showcase-container">

            <div className="product-showcase-display-container product-boathouse-rentee-app-showcase-display-container">
                <div className="product-showcase-info-container product-boathouse-rentee-app-showcase-info-container">
                    <div className="product-showcase-logo-container product-boathouse-rentee-app-showcase-logo-container">
                        <Logo variant="full" size="small" mode="light" />
                    </div>
                    <div className="product-showcase-title-container product-boathouse-rentee-app-showcase-title-container">
                        <TitleField title={product.name} level={2} bold={true} fontSize='3rem' />
                    </div>
                    <div className="product-showcase-overview-container product-boathouse-rentee-app-showcase-overview-container">
                        <TextField text={product.overview} fontColor="#666666" fontSize='1.1rem' />
                    </div>
                </div>
                <div className="product-visual-container product-boathouse-rentee-app-visual-container">
                    <img 
                        className="product-visual-image product-boathouse-rentee-app-visual-image" 
                        src={product.visual} 
                        alt={`${product.name} preview`}
                        draggable={false}
                     />
                </div>
            </div>
            <div className="product-feature-container product-boathouse-rentee-app-feature-container">
                <FeatureCard title={product.features[0].title} description={product.features[0].description} icon={product.features[0].icon} orientation={featureOrientation} />
                <FeatureCard title={product.features[1].title} description={product.features[1].description} icon={product.features[1].icon} orientation={featureOrientation} />
                <FeatureCard title={product.features[2].title} description={product.features[2].description} icon={product.features[2].icon} orientation={featureOrientation} />
            </div>
        </section>
    );
};

export default BoatHouseRentee;
